import { getErrorsFromConditions } from '@/common/components/ConditionsEditor/helpers'

import { errorTypes } from './constants'

const validateConditions = conditions => {
  if (!conditions || conditions.length === 0) {
    return [{ type: errorTypes.conditionsEmpty }]
  }

  return getErrorsFromConditions(conditions)
}

export const validateShippingAvailabilityCriterion = criterion => {
  const errors = []

  if (!criterion.name?.trim()) {
    errors.push({ type: errorTypes.nameEmpty })
  }

  errors.push(...validateConditions(criterion.conditions))

  return errors
}
